import { render, staticRenderFns } from "./CarDetailedList.vue?vue&type=template&id=2a881e1f&scoped=true&"
import script from "./CarDetailedList.vue?vue&type=script&lang=js&"
export * from "./CarDetailedList.vue?vue&type=script&lang=js&"
import style0 from "./CarDetailedList.vue?vue&type=style&index=0&id=2a881e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a881e1f",
  null
  
)

export default component.exports